<template>
  
  <base-driver-route-card :route="route">
  
    <template v-slot:footer>
      
      <div
        class="text-neutral-lighter flex items-center justify-between gap-5 max-md:flex-col"
      >
      
        <div class="flex flex-col gap-2">


     
        </div>

         <div v-if="!hideBooking">
         <!-- <rounded-button
            v-if="route.is_reservation"
            class="bg-secondary max-md:px-24"
            disabled
            design="4"
          >
            EN ATTENTE DE VALIDATION
          </rounded-button> -->
          <!-- <rounded-button
            disabled
            v-if="route.is_mine"
            class="max-md:px-24"
            design="4"
          >
        
            MON TARIF
          </rounded-button> -->
          
          <rounded-button
            v-if="!route.is_mine"
            class="max-md:px-24"
            design="3"
            @click="$emit('book', route)"
          >
          
          Je propose mon tarif pour ce trajet
          </rounded-button>
        </div>
      </div>
    </template>
  </base-driver-route-card>
</template>

<script setup>
import { defineProps } from "vue";
const { $api } = useNuxtApp();
const router = useRouter();
const props = defineProps({
  route: {
    type: Object,
    required: true,
    default: () => ({}),
  },
  hideBooking: {
    type: Boolean,
    default: false,
  },
});

const forfaitChecked = ref(false);


// Watch for changes in the checkbox state
watch(forfaitChecked, () => {

});

// Perform adjustment on page load based on the initial state of forfaitChecked


onMounted(async () => {
  const isCheckboxVisible = ref(true);
  await nextTick(); // Ensure the DOM is updated
  const dialogElement = document.querySelector('.p-dialog.p-component');
 const checkboxInput = document.querySelector('#forfait_demarche_mb');

  if (!dialogElement) {
//checkboxInput.style.display = 'block'; 
  //  checkboxInput.disabled = false; 
  
 //  adjustPricing();  // Apply pricing adjustments if the dialog is present
  }else{
  //checkboxInput.style.display = 'none'; 
    //checkboxInput.disabled = true; 
  }
});
</script>
